import React, {useState, useEffect} from 'react';
import {withStyles, Grid, Dialog, Typography} from '@material-ui/core';
import {translate} from 'react-admin';
import {compose} from 'recompose';
import ImageUploader from '../ImageUploader';
import {connect} from 'react-redux';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import {
  initSendImage,
  resetSendImage,
  sendProfileImage,
  sendUserImage,
} from '../ImageUploader/store/action';
import {getEmail, hasRoles} from '../../utils/auth';

const styles = theme => ({
  container: {
    width: 100 + '%',
    textAlign: 'center',
  },
  avatar: {
    borderRadius: 100 + '%',
    border: 1 + 'px solid whitesmoke',
    maxWidth: 100 + '%',
    maxHeight: 100 + '%',
  },
  edit: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingTop: 0.5 + 'em',
  },
  blankAvatar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: 150,
    height: 150,
    borderRadius: 100 + '%',
    border: '1px solid #cecece',
    fontSize: 90,
    color: '#666',
  },
  delete: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingTop: 0.5 + 'em',
  },
});

const Avatar = ({
  translate,
  classes,
  initSendImage,
  resetSendImage,
  sendProfileImage,
  sendUserImage,
  isUpdated,
  image,
  text = 'Avatar',
  type,
  data,
}) => {
  const imageSource =
    'profile' === type || 'user' === type
      ? image
      : `${process.env.REACT_APP_API_ENTRYPOINT}/${image}`;

  const [imageExists, setImageExists] = useState(true);
  useEffect(() => {
    fetch(imageSource).then(res => setImageExists(res.ok));
  }, []);

  return (
    <Grid container direction="column">
      <Grid item>
        <div className={classes.container}>
          {image && imageExists ? (
            <img
              src={imageSource}
              alt="avatar"
              className={classes.avatar}
              width="150"
              height="150"
            />
          ) : (
            <div className={classes.blankAvatar}>
              <PhotoCamera fontSize="inherit" color="inherit" />
            </div>
          )}
        </div>
      </Grid>
      {'programs' !== type && (
        <Grid item>
          <>
            <Typography
              className={classes.edit}
              onClick={() => initSendImage()}>
              {translate('custom.commons.edit')}
            </Typography>
            {data && hasRoles(['ROLE_CLIENT_ADMIN']) && image !== null && (
              <Typography
                className={classes.delete}
                onClick={() => sendUserImage(data.id, null)}>
                {translate('custom.commons.delete')}
              </Typography>
            )}
            {!data && image !== null && (
              <Typography
                className={classes.delete}
                onClick={() =>
                  sendProfileImage({
                    imageBase64: null,
                  })
                }>
                {translate('custom.commons.delete')}
              </Typography>
            )}
            <Dialog
              open={isUpdated === 'ready'}
              onClose={() => resetSendImage()}
              scroll="body">
              <ImageUploader type={type} data={data} />
            </Dialog>
          </>
        </Grid>
      )}
    </Grid>
  );
};

const mapStateToProps = ({imageReducer}) => ({
  isUpdated: imageReducer.isUpdated,
});

export default compose(
  translate,
  connect(mapStateToProps, {
    initSendImage,
    resetSendImage,
    sendProfileImage,
    sendUserImage,
  }),
  withStyles(styles),
)(Avatar);
